import React, { useEffect } from 'react';
import { useTheme } from '../hooks/useTheme';

/**
 * Notification modal replacing alert() for save/publish success and errors.
 * Auto-closes after 2s on success.
 */
const DiagramToastModal = ({ isOpen, type = 'success', title, message, onClose }) => {
  const { theme } = useTheme();

  useEffect(() => {
    if (!isOpen || type !== 'success') return;
    const t = setTimeout(onClose, 2000);
    return () => clearTimeout(t);
  }, [isOpen, type, onClose]);

  if (!isOpen) return null;

  const isError = type === 'error';
  const accentColor = isError ? '#ef4444' : '#22c55e';

  const overlay = {
    position: 'fixed', inset: 0, zIndex: 9000,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  };
  const box = {
    background: theme.toolbar?.background || '#fff',
    color: theme.toolbar?.text || '#1e293b',
    border: `1px solid ${theme.toolbar?.border || '#e2e8f0'}`,
    borderRadius: 10,
    padding: '24px 28px',
    minWidth: 320,
    maxWidth: 440,
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={box} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: message ? 8 : 16 }}>
          <span style={{ fontSize: 20, color: accentColor, lineHeight: 1 }}>
            {isError ? '✕' : '✓'}
          </span>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>{title}</h3>
        </div>
        {message && (
          <p style={{ margin: '0 0 16px', fontSize: 13, opacity: 0.75 }}>{message}</p>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '7px 18px', borderRadius: 6, cursor: 'pointer',
              background: accentColor, border: 'none', color: '#fff',
              fontSize: 13, fontWeight: 600,
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiagramToastModal;
